import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminRoutingModule} from "./admin-routing.module";
import {PendingEventsComponent} from './pending-events/pending-events.component';
import {AllEventsComponent} from './all-events/all-events.component';
import {SharedModule} from "../../shared/shared.module";
import {BreadcrumbModule} from "primeng/breadcrumb";
import {ReportsComponent} from './reports/reports.component';
import {ReportFiltersComponent} from './reports/report-filters/report-filters.component';
import {ButtonModule} from "primeng/button";
import {DatePickerModule} from "primeng/datepicker";
import {SelectModule} from "primeng/select";
import {InputTextModule} from "primeng/inputtext";
import {PaginatorModule} from "primeng/paginator";
import {ReactiveFormsModule} from "@angular/forms";
import {TableModule} from "primeng/table";
import {ComplaintDropDownComponent} from './reports/complaint-drop-down/complaint-drop-down.component';
import {MenuModule} from "primeng/menu";
import { UsersComponent } from './users/users.component';
import { UserFiltersComponent } from './users/user-filters/user-filters.component';
import { UserDropDownComponent } from './users/user-drop-down/user-drop-down.component';
import { UserTableListComponent } from './users/user-table-list/user-table-list.component';
import { AdminUserAlterPrivilegeModalComponent } from './users/modals/admin-user-alter-privilege-modal/admin-user-alter-privilege-modal.component';
import { AdminUserBlockModalComponent } from './users/modals/admin-user-block-modal/admin-user-block-modal.component';
import { FeedbacksComponent } from './feedbacks/feedbacks.component';
import { FeedbackFiltersComponent } from './feedbacks/feedback-filters/feedback-filters.component';
import { FeedbackDropDownComponent } from './feedbacks/feedback-drop-down/feedback-drop-down.component';
import {AccordionModule} from "primeng/accordion";
import { EventsToRemoveComponent } from './events-to-remove/events-to-remove.component';


@NgModule({
  declarations: [
    PendingEventsComponent,
    AllEventsComponent,
    ReportsComponent,
    ReportFiltersComponent,
    ComplaintDropDownComponent,
    UsersComponent,
    UserFiltersComponent,
    UserDropDownComponent,
    UserTableListComponent,
    AdminUserAlterPrivilegeModalComponent,
    AdminUserBlockModalComponent,
    FeedbacksComponent,
    FeedbackFiltersComponent,
    FeedbackDropDownComponent,
    EventsToRemoveComponent
  ],
    imports: [
        CommonModule,
        AdminRoutingModule,
        SharedModule,
        BreadcrumbModule,
        ButtonModule,
        DatePickerModule,
        SelectModule,
        InputTextModule,
        PaginatorModule,
        ReactiveFormsModule,
        TableModule,
        MenuModule,
        AccordionModule
    ]
})
export class AdminModule {
}
